import type { AdminBillingManager } from '@/state/useAdminBilling';
import { Input } from '@/components/ui/input';
import { ConfirmDialog } from '@/components/Dialogs/ConfirmDialog';
import { formatBillingDate } from '@/state/billing/billing-format';
import { Field, FIELD_CONTROL } from '../../Dashboard/ConsolePanel';

type ExtendTrialDialogProps = { manager: AdminBillingManager };

/**
 * The "free period" tool: sets a new trialEnd on the company's live Polar
 * subscription. Our own subscriptions.trialEnd is left for the webhook consumer
 * to update once Polar's subscription.updated event arrives; this dialog only
 * tells Polar to change it.
 */
export const ExtendTrialDialog = ({ manager }: ExtendTrialDialogProps) => {
  const { extendingTrialFor: company, trialEndDate, setTrialEndDate, trialEndBlockingReason } = manager;

  return (
    <ConfirmDialog
      open={!!company}
      title={`Extend trial: ${company?.name ?? ''}`}
      description={company?.trialEnd ? `The trial currently ends ${formatBillingDate(company.trialEnd)}.` : undefined}
      confirmLabel="Set trial end"
      disabled={!!trialEndBlockingReason}
      disabledReason={trialEndBlockingReason}
      onConfirm={manager.confirmExtendTrial}
      onCancel={manager.closeExtendTrial}
    >
      <Field label="New trial end date" htmlFor="extend-trial-date" hint="The first charge moves to this date.">
        <Input
          id="extend-trial-date"
          type="date"
          value={trialEndDate}
          onChange={(ev) => setTrialEndDate(ev.target.value)}
          className={FIELD_CONTROL}
        />
      </Field>
    </ConfirmDialog>
  );
};
